<!--机构开户结果-->

<template>
  <div class="in-review">
    <!--  开户资料审核中-->
    <template v-if="result.account_status == 2">
      <img
        class="success-icon light"
        src="@/assets/images/open_account_in_review_dark.png"
      />
      <img
        class="success-icon dark"
        src="@/assets/images/open_account_in_review_dark.png"
      />
      <p class="title">{{ $t('openInstitutionServices.g000017') }}</p>
      <div class="text-box">
        <p class="text">{{ $t('mki18n.t00023') }}</p>
        <p class="text">{{ $t('mki18n.t00024') }}</p>
        <p class="text">{{ $t('mki18n.t00025') }} <a class="link" @click="showService">{{ $t('check_progress.status_tip_next') }}</a></p>
      </div>
      <OpenAccountStep></OpenAccountStep>
    </template>
    <!--    线下资料审核中-->
    <template v-if="result.account_status == 17">
      <img
        class="success-icon light"
        src="@/assets/images/open_account_in_review_dark.png"
      />
      <img
        class="success-icon dark"
        src="@/assets/images/open_account_in_review_dark.png"
      />
      <p class="title">{{ $t('openInstitutionServices.g000018') }}</p>
      <div class="text-box">
        <p class="text">{{ $t('mki18n.t00023') }}</p>
        <p class="text">{{ $t('mki18n.t00024') }}</p>
        <p class="text">{{ $t('mki18n.t00025') }} <a class="link" @click="showService">{{ $t('check_progress.status_tip_next') }}</a></p>
      </div>
      <OpenAccountStep :step1Text="$t('openInstitutionServices.g000019')"></OpenAccountStep>
    </template>
    <!--    开户资料驳回-->
    <template v-if="result.account_status == 3">
      <img
        class="success-icon light"
        src="@/assets/images/account-activation-2.png"
      />
      <img
        class="success-icon dark"
        src="@/assets/images/account-activation-2.png"
      />
      <p class="title">{{ $t('openInstitutionServices.g000020') }}</p>
      <div class="text-box">
        <p class="text" style="text-align: center">{{ $t('openInstitutionServices.g000021') }}<a class="link" @click="showService">{{ $t('check_progress.status_tip_next') }}</a>{{ $t('openInstitutionServices.g000022') }}</p>
      </div>
      <OpenAccountStep :status-text="$t('openInstitutionServices.g000023')"></OpenAccountStep>
    </template>

    <!--    线下资料驳回-->
    <template v-if="result.account_status == 18">
      <img
        class="success-icon light"
        src="@/assets/images/account-activation-2.png"
      />
      <img
        class="success-icon dark"
        src="@/assets/images/account-activation-2.png"
      />
      <p class="title">{{ $t('openInstitutionServices.g000024') }}</p>
      <div class="text-box">
        <p class="text" style="text-align: center">{{ $t('openInstitutionServices.g000021') }}<a class="link" @click="showService">{{ $t('check_progress.status_tip_next') }}</a>{{ $t('openInstitutionServices.g000022') }}</p>
      </div>
      <OpenAccountStep :step1Text="$t('openInstitutionServices.g000019')" :status-text="$t('openInstitutionServices.g000023')"></OpenAccountStep>
    </template>
  </div>
</template>


<script>
import OpenAccountStep from "@/components/OpenAccountStep.vue";
import bus from "@/utils/bus";

export default {
  components: { OpenAccountStep },
  data(){
    return{
      result: {
        account_status: ''
      }
    }
  },
  created () {
    this.getData();
  },
  methods: {
    getData() {
      this.$apis.accountSituationV2({
        hideFields: 'config_data'
      }).then(res => {
        this.result = res;
      })
    },
    showService(){
      bus.$emit('showService')
    }
  }
}
</script>

<style scoped lang="less">

.in-review {
  padding: 84px 48px;
  text-align: center;
  line-height: 1;

  .success-icon {
    margin: 0 auto;
    width: 120px;
    height: 120px;
    &.dark{
      display: none;
    }
  }

  .title {
    margin-top: 48px;
    font-size: 40px;
    font-weight: bold;
    color: #17161C;
  }

  .text-box{
    width: 100%;
    text-align: left;
    line-height: 40px;
    margin: 44px 0 60px;
    padding-bottom: 60px;
    border-bottom: 0.5px solid #f3f3f3;
    .text{
      margin-bottom: 10px;
      &.tc{
        text-align: center;
      }
      .link{
        color: #328CF4;
        text-decoration: underline;
      }
    }
  }

  .info-box {
    margin-top: 40px;

    padding-top: 10px;
    position: relative;
    &:after{
      content: '';
      position: absolute;
      top: 0;
      left: -50%;
      width: 200%;
      height: 1px;
      background: rgba(0,0,0,0.06);
      transform: scale(0.5);
    }
    .item {
      display: flex;
      line-height: 75px;
      font-size: 28px;

      .label {
        width: 300px;
        color: #747377;
      }

      .value {
        color: #17161C;
        font-weight: 500;
      }
    }
  }

  ::v-deep .van-action-sheet__gap{
    //background-color: #232430;
    display: none;
  }
  ::v-deep .van-action-sheet__cancel{
    font-size: 28px;
  }
}
.actions-box{
  padding: 0 20px;
  .item{
    display: flex;
    justify-content: center;
    line-height: 100px;
    font-size: 28px;
    a{
      color: #0F0F2F;
      font-weight: 400;
    }
    .service{
      line-height: 40px;
      text-align: center;
      padding: 10px 0;
      position: relative;
      width: 100%;
      p{
        font-size: 24px;
      }
      .van-icon{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 40px;
      }
    }
  }
}

.black-theme{
  .in-review{
    color: #fff;
    .success-icon{
      &.light{
        display: none;
      }
      &.dark{
        display: block;
      }
    }
    .title{
      color: #fff;
    }
    .info-box{
      &:after{
        background: rgba(255,255,255,0.25);
      }
      .item{
        .label{
          color: #9D9D9F;
        }
        .value{
          color: #fff;
        }
      }
    }
  }
  .actions-box{
    .item{
      a{
        color: #fff;
      }
    }
  }
}
</style>